export default __webpack_public_path__ + "static/media/7bfc355a707141ab15a19bc50e0ba9c0.png";